import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import AppComponent from './AppComponent';
import DraftModalContainer from '../modals/draftModal/DraftModalContainer';
import DisclaimerModalContainer from '../modals/disclaimerModal/DisclaimerModalContainer';
import * as appActions from './AppActions';
import * as NotFoundActions from '../notFound/NotFoundActions';
import './Style';

class StoryAppContainer extends Component {
    constructor(props) {
      super(props)

      this.state = {
        error: null,
        errorInfo: null
      }
    }

    componentDidMount() {
        const { pathname, appActions, notFoundActions } = this.props;
        const idMatches = pathname.match(/\/([0-9]+)(\/|$)/);
        const type = pathname.match(/\/(b|u|r)(\/|$)/);
        const tourId = idMatches && Number.isInteger(+idMatches[1]) ? +idMatches[1] : 0;
        let tourTypeStr = type ? type[1] : '';
        let tourType = '';

        switch (tourTypeStr) {
            case 'r':
                tourType = 'restricted';
                break;
            case 'u':
                tourType = 'unbranded';
                break;
            case 'b':
                tourType = 'branded';
                break;
            default:
                tourType = 'branded';
                break;
        }

        if (tourId) {
            appActions.setUrlParams(tourId, tourType);
        } else {
            notFoundActions.redirectToNotFound();
        }

        if (!tourTypeStr || /^\?cookieModeOff=1$/.test(this.props.location.search)) {
            this.props.appActions.redirectToHome();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.tourId != nextProps.tourId
                || this.props.tourType != nextProps.tourType) {
            this.props.appActions.getTour(nextProps.tourId, nextProps.tourType);
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        })
    }

    render() {
        const { pathname, tourId, getTourFulfilled, getTourError } = this.props;
        const { error } = this.state;

        if (error) {
            return null;
        }

        if ((pathname.indexOf('notFound') === -1
                && (tourId === 0 || !getTourFulfilled)) || getTourError.length) {
            return <div className="loader"></div>;
        }

        return (
            <AppComponent blurValue={this.props.contentBlur} pathname={this.props.pathname}>
                <DraftModalContainer />
                <DisclaimerModalContainer />
            </AppComponent>
        );
    }
}

StoryAppContainer.propTypes = {
    tourId: PropTypes.number.isRequired,
    tourType: PropTypes.string,
    getTourFulfilled: PropTypes.bool.isRequired,
    getTourError: PropTypes.string.isRequired,
    isDrafted: PropTypes.bool.isRequired,
    isLogined: PropTypes.bool.isRequired,
    pathname: PropTypes.string.isRequired
};

const mapStateToProps = (state) => {
    return {
        tourId: state.app.tourId,
        tourType: state.app.tourType,
        getTourFulfilled: state.app.getTourFulfilled,
        getTourError: state.app.getTourError,
        contentBlur: state.app.contentBlur,
        isDrafted: state.app.isDrafted,
        isLogined: state.app.isLogined,
        location: state.routing.location,
        pathname: state.routing.location.pathname,
        theme: state.app.theme
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        notFoundActions: bindActionCreators(NotFoundActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StoryAppContainer)
